import React, { useState } from 'react';

import { colors } from '@nw/shared/config';

import { CloseModalIcon } from '../../icons/CloseModalIcon';

import {
  BannerFieldWrapper,
  CloseBannerContainer,
  Description,
  HeadingAndDescriptionContainer,
  Image,
  ImageContainer
} from './styledComponent';

interface BannerFieldProps {
  isCloseAllow?: boolean;
  imgLink?: string;
  altText?: string;
  description?: string;
  heading?: string;
}

export const BannerField = (props: BannerFieldProps): React.ReactElement => {
  const [shouldShowBanner, setShouldShowBanner] = useState(true);

  const { isCloseAllow, imgLink, altText, description, heading } = props;

  const onClickCloseBtn = () => {
    setShouldShowBanner(false);
  };

  const renderBannerField = () => {
    return (
      <BannerFieldWrapper>
        <ImageContainer>
          <Image src={imgLink} alt={altText} />
        </ImageContainer>
        {isCloseAllow && (
          <CloseBannerContainer onClick={onClickCloseBtn}>
            <CloseModalIcon fill={colors.slateGray} />
          </CloseBannerContainer>
        )}
        <HeadingAndDescriptionContainer>
          <Description
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        </HeadingAndDescriptionContainer>
      </BannerFieldWrapper>
    );
  };

  return shouldShowBanner ? renderBannerField() : null;
};
